import React, {useState} from 'react';

import './AppShellCustomer.css';

import {
  // Content,
  Header,
  // HeaderMenuButton,
  HeaderName,
  // HeaderNavigation,
  // HeaderMenu,
  // HeaderMenuItem,
  HeaderGlobalBar,
  HeaderGlobalAction,
  HeaderPanel,
  // HeaderSideNavItems,
  // SkipToContent,
  // SideNav,
  // Temporarily comment these out until they are needed again
  // SideNavHeader,
  // SideNavDetails,
  // SideNavSwitcher,
  // SideNavItems,
  // SideNavLink,
  // SideNavMenu,
  // SideNavMenuItem,
  Switcher,
  SwitcherItem,
  SwitcherDivider,
} from 'carbon-components-react';

import { Notification20, Help20 } from '@carbon/icons-react';

import headerLogo from '../../cwc-clientside-logo.png'


function AppShellCustomer(props) {

  const {isAuthenticated} = props //DEBUG FIX UNMONUNT RENDER
  // maybe you can put a timer here and render a loading for a few seconds, so the
  //is authenticated can catch up and won't go render the offline shit if you are logged in
  // so put a timer here, let the isAuthenticated catch up and then render if isauth is still false. will not stay false for long.

  const [menu, setMenu] = useState(false)

  return (
    <div>
      <Header id="customerSideHeader" aria-label="CWC Platform" >
       <HeaderName href="/" prefix="">
         <img width="345" src={headerLogo} />

       </HeaderName>
       <HeaderGlobalBar>

         {/*<HeaderGlobalAction
           aria-label="Notifications"
           onClick={() => console.log('notification click?')}>
           <Notification20 />
         </HeaderGlobalAction> */}

         { /*
         <HeaderGlobalAction
           aria-label="App Switcher"
           isActive
           onClick={ () => setMenu(!menu)}>
           <Help20 />
         </HeaderGlobalAction>
          */ }

       </HeaderGlobalBar>
       <HeaderPanel id="customerHeaderPanel" aria-label="Header Panel" expanded={menu}>
         { /*
         <Switcher aria-label="Switcher Container">
           <SwitcherItem aria-label="Link 1" href="/">
             Live Inventory
           </SwitcherItem>
           <SwitcherItem href="/quote-creator" aria-label="Link 2">
             Quote Creator
           </SwitcherItem>
           <SwitcherItem href="/quote-database" aria-label="Link 3">
             Quote Database
           </SwitcherItem>
           <SwitcherItem href="#" aria-label="Link 4">
             Sales Orders
           </SwitcherItem>
           <SwitcherItem href="#" aria-label="Link 5">
             Documentation
           </SwitcherItem>
           <SwitcherDivider />
           <SwitcherItem id="logout-menu-section" href="/" onClick={ () => console.log("asad")} aria-label="Link 6">
             <strong>Log Out</strong> <span id="userEmailLogoutBtn">[asd]</span>
           </SwitcherItem>
         </Switcher>
       */}
       </HeaderPanel>

     </Header>
     <div id="appContent">
       {props.children}
     </div>
    </div>

  );
}

export default AppShellCustomer;
